module.exports = __webpack_public_path__ + "images/dingtalk/init-files@2x-e712dc23e90e4451d8ba6a8a67cb027e.png";